import axiosInstance from '../axiosInstance';
import { NOTIFICATION_EVENT_ENDPOINTS } from '../endpoints';

const notificationEventService = {
  getAll: async (organizationId) => {
    const params = organizationId ? { organizationId } : {};
    const response = await axiosInstance.get(NOTIFICATION_EVENT_ENDPOINTS.LIST, { params });
    return response.data;
  },

  getByEventType: async (eventType, organizationId) => {
    const params = organizationId ? { organizationId } : {};
    const response = await axiosInstance.get(NOTIFICATION_EVENT_ENDPOINTS.GET_BY_EVENT(eventType), { params });
    return response.data;
  },

  updateRules: async (eventType, rules, organizationId) => {
    const params = organizationId ? { organizationId } : {};
    const response = await axiosInstance.put(
      NOTIFICATION_EVENT_ENDPOINTS.UPDATE(eventType),
      { eventType, rules },
      { params }
    );
    return response.data;
  },

  resetToDefault: async (eventType, organizationId) => {
    const params = organizationId ? { organizationId } : {};
    const response = await axiosInstance.delete(
      NOTIFICATION_EVENT_ENDPOINTS.RESET(eventType),
      { params }
    );
    return response.data;
  },
};

export default notificationEventService;
